<template>
  <b-dropdown id="dropdown-left" variant="primary">
    <template slot="button-content">
      <plus-box-icon></plus-box-icon>
      <span v-if="full"> Insert New Widget</span>
    </template>
    <b-dropdown-item
      v-for="type in simple_field_types"
      :key="type.code"
      href=""
      @click="addField(type)"
      ><component :is="type.icon" /> {{ type.name }}</b-dropdown-item
    >

    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item
      v-for="type in container_field_types"
      :key="type.code"
      href=""
      @click="addField(type)"
      ><component :is="type.icon" /> {{ type.name }}</b-dropdown-item
    >

    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item
      v-for="type in misc_field_types"
      :key="type.code"
      href=""
      @click="addField(type)"
      ><component :is="type.icon" /> {{ type.name }}</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
import { filter, cloneDeep } from "lodash";
import { FIELD_TYPES } from "./field_types.js";
import PlusBoxIcon from "vue-material-design-icons/PlusBox.vue";
import FormTextboxIcon from "vue-material-design-icons/FormTextbox.vue";
import NoteTextIcon from "vue-material-design-icons/NoteText.vue";
import CheckboxMarkedOutlineIcon from "vue-material-design-icons/CheckboxMarkedOutline.vue";
import NumericIcon from "vue-material-design-icons/Numeric.vue";
import CurrencyUsdIcon from "vue-material-design-icons/CurrencyUsd.vue";
import CalendarTextIcon from "vue-material-design-icons/CalendarText.vue";
import FormatListChecksIcon from "vue-material-design-icons/FormatListChecks.vue";
import CloudUploadIcon from "vue-material-design-icons/CloudUpload.vue";
import WindowMaximizeIcon from "vue-material-design-icons/WindowMaximize.vue";
import CodeEqualIcon from "vue-material-design-icons/CodeEqual.vue";
import TableColumnPlusAfterIcon from "vue-material-design-icons/TableColumnPlusAfter.vue";
import TablePlusIcon from "vue-material-design-icons/TablePlus.vue";
import LanguageHtml5Icon from "vue-material-design-icons/LanguageHtml5.vue";
import CalculatorVariantIcon from "vue-material-design-icons/CalculatorVariant.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "FAddField",
  components: {
    PlusBoxIcon,
    FormTextboxIcon,
    NoteTextIcon,
    CheckboxMarkedOutlineIcon,
    NumericIcon,
    CurrencyUsdIcon,
    CalendarTextIcon,
    FormatListChecksIcon,
    CloudUploadIcon,
    WindowMaximizeIcon,
    CodeEqualIcon,
    TableColumnPlusAfterIcon,
    TablePlusIcon,
    LanguageHtml5Icon,
    CalculatorVariantIcon,
  },
  model: {
    prop: "fields",
    event: "change",
  },
  props: {
    fields: { type: Array, default: () => [] },
    formState: {
      type: Object,
      default: () => {},
    },
    full: { type: Boolean, default: false },
    selector: { type: Object, default: null },
  },
  data: function () {
    return {};
  },
  methods: {
    addField(typeDef) {
      var newItemNo = this.fields.length + 1;

      var newField = {
        id: uuidv4(),
        display_order: newItemNo,
        field_type: typeDef.code,
        code: typeDef.code + "_" + newItemNo,
        name: typeDef.name + " " + newItemNo,
        params: cloneDeep(typeDef.params),
        value: cloneDeep(typeDef.value),
        has_score: false,
        max_score: 100,
        min_score: 0,

        _locked: false,
        _newfield: true,
      };

      if (typeDef.container === true) {
        newField.fields = []; // init blank array
      }

      var fields = this.fields || [];

      fields.push(newField);

      if (this.formState) this.formState.dirty = true;

      this.$emit("change", fields);
      if (this.selector) {
        this.selector.selectThis(newField, this.fields);
        this.selector.editThis(newField, this.fields);
      }
    },
  },
  computed: {
    visible_field_types() {
      return filter(FIELD_TYPES, "show");
    },
    simple_field_types() {
      return filter(this.visible_field_types, {
        simple: true,
        container: false,
        misc: false,
      });
    },
    container_field_types() {
      return filter(this.visible_field_types, { container: true, misc: false });
    },
    misc_field_types() {
      return filter(this.visible_field_types, { misc: true });
    },
  },
};
</script>

<style scoped></style>
